import script from "./VideoFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoFrame.vue?vue&type=script&setup=true&lang=js"

import "./VideoFrame.vue?vue&type=style&index=0&id=3d027a42&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d027a42"]])

export default __exports__